import { Box } from 'components/Bridge/Box';

const BridgePage = () => {
  return <Box />;
};

export { BridgePage };
